import { render, staticRenderFns } from "./resolveByText.vue?vue&type=template&id=f3ac8cc4&"
import script from "./resolveByText.vue?vue&type=script&lang=js&"
export * from "./resolveByText.vue?vue&type=script&lang=js&"
import style0 from "./resolveByText.vue?vue&type=style&index=0&id=f3ac8cc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports